module.exports = __webpack_public_path__ + "img/stamp.57b46d521c40b49b58b749ac98dd853e.svg";